import TitleInput from "Components/Common/Input/TextBoxes/TitleInput/TitleInput";
import MediaUpload from "Components/Common/MediaUpload/MediaUpload";
import ContentView from "Components/ContentView/ContentView";
import i18n from "i18next";
import { AuditTemplate } from "Models/Audit/AuditTemplate";
import * as React from "react";
import styles from "./AuditTemplateInfo.scss";

interface IProps {
    auditTemplate: AuditTemplate;
    onChange?: (name: string, isMediaChanged: boolean, pictureFile?: File) => void;
}

interface IState {
    name: string;
    auditTemplateId: number | undefined;
    isNameFocussed: boolean;
    pictureFile?: File;
}

export class AuditTemplateInfo extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            name: props.auditTemplate.name,
            auditTemplateId: props.auditTemplate.id,
            isNameFocussed: false
        };

        this.onNameChanged = this.onNameChanged.bind(this);
        this.onMediaChanged = this.onMediaChanged.bind(this);
    }

    public onNameChanged(newValue: string) {
        this.setState({ name: newValue });

        if (this.props.onChange) {
            this.props.onChange(newValue, false, this.state.pictureFile);
        }
    }

    public onMediaChanged(state: { imageFile?: File }): void {
        this.setState({ pictureFile: state.imageFile });

        if (this.props.onChange) {
            this.props.onChange(this.state.name, true, state.imageFile);
        }
    }

    public static getDerivedStateFromProps(nextProps: IProps, prevState: IState): Partial<IState> {
        const partialState: Partial<IState> = {};

        if (nextProps.auditTemplate && nextProps.auditTemplate.id !== prevState.auditTemplateId) {
            partialState.auditTemplateId = nextProps.auditTemplate.id;
            partialState.name = nextProps.auditTemplate.name;
        }

        return partialState;
    }

    public render() {
        return (
            <ContentView>
                <div className={styles.auditTemplateInfo}>
                    <div className={styles.info}>
                        {this.props.auditTemplate.id ? (
                            <div id="divAuditTemplateId" className={styles.auditTemplateId}>{i18n.t("audits.properties.auditId")}: {this.state.auditTemplateId}</div>
                        ) : (
                                <div className={styles.auditTemplateId}>{i18n.t("audits.newAudit")}</div>
                            )}
                        <TitleInput id="txtAuditTemplateName" value={this.state.name} onChange={this.onNameChanged} placeholder={i18n.t("audits.placeholders.auditTitle")} />
                    </div>
                    <div className={styles.media}>
                        <MediaUpload
                            id="mduAuditTemplateMedia"
                            imageUrl={this.props.auditTemplate.pictureUrl}
                            onChange={this.onMediaChanged}
                            isImageUploadOnly={true} />
                    </div>
                </div>
            </ContentView>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Components/Pages/AuditTemplateDetailView/AuditTemplateInfo/AuditTemplateInfo.tsx